import React from "react";
import { Check } from "lucide-react";
import { money } from "@/lib/pricing";

// Reusable catering sides selector. `value` is an array of
// { product_id, name, price }. Toggling adds/removes a side.
export function SidesPicker({ options, value, onChange, requiredCount = 0 }) {
  const selectedIds = new Set((value || []).map((s) => s.product_id));

  const toggle = (opt) => {
    if (selectedIds.has(opt.id)) {
      onChange((value || []).filter((s) => s.product_id !== opt.id));
    } else {
      onChange([...(value || []), { product_id: opt.id, name: opt.name, price: opt.price || 0 }]);
    }
  };

  const count = (value || []).length;
  const needMore = requiredCount > 0 && count < requiredCount;

  return (
    <div data-testid="sides-picker">
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-semibold" style={{ color: "var(--ink)" }}>
          Choose your sides
          {requiredCount > 0 && <span className="ml-1" style={{ color: "var(--muted)" }}>· pick at least {requiredCount}</span>}
        </div>
        <span className="text-xs font-semibold" style={{ color: needMore ? "#b91c1c" : "var(--muted)" }} data-testid="sides-count">
          {count} selected
        </span>
      </div>
      <div className="space-y-2">
        {options.map((opt) => {
          const sel = selectedIds.has(opt.id);
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => toggle(opt)}
              data-testid={`side-option-${opt.id}`}
              className="w-full flex items-center justify-between rounded-xl px-4 py-3 text-left transition"
              style={sel ? { border: "2px solid var(--brand)", background: "var(--accent-soft)" } : { border: "1px solid var(--border)", background: "var(--surface)" }}
            >
              <div className="flex items-center gap-3 min-w-0">
                <span
                  className="h-5 w-5 rounded-md flex items-center justify-center shrink-0"
                  style={sel ? { background: "var(--brand)", color: "var(--brand-fg)" } : { border: "1px solid var(--border)" }}
                >
                  {sel && <Check size={14} />}
                </span>
                <span className="font-semibold truncate" style={{ color: "var(--ink)" }}>{opt.name}</span>
              </div>
              <span className="text-sm font-semibold shrink-0" style={{ color: "var(--brand)" }}>
                {opt.price ? `+${money(opt.price)}` : "Included"}
              </span>
            </button>
          );
        })}
        {options.length === 0 && (
          <div className="text-sm rounded-xl p-3" style={{ background: "var(--surface-2)", color: "var(--muted)" }}>
            No sides available right now.
          </div>
        )}
      </div>
    </div>
  );
}
